"use strict";

exports.__esModule = true;
exports.EventTimelineContext = void 0;
var _EventTimelineController = require("../EventTimelineController");
var _Utils = require("../../../Utils");
/**
 * Provides a configured EventTimeline object to consumers.
 * @component
 */

var EventTimelineContext = exports.EventTimelineContext = (0, _Utils.createEnhancedContext)({
  propName: "data",
  defaultController: _EventTimelineController.EventTimelineController
});